/**
 * setLanguage - DEPRECATED. Language is now determined by the URL prefix /:lang.
 * Navigate to /:lang/... or use the LanguageSwitch component to change language.
 * @returns {void}
 * @deprecated
 */
export default function setLanguage() {
    // no-op — language is now carried by the URL prefix /:lang
}
